import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { PageSectionLayout } from "@/elements-react/page-section-layout";
import { LayoutStyleTypes } from "@/util-react/layout";
import { B2bHero } from "@/elements-react/b2b-hero";
import { WorkFasterMobile } from "@/elements-react/work-faster/work-faster-mobile";
import { TargetAudienceMobile } from "@/elements-react/target-audience/target-audience-mobile";
import { ComparisonSectionMobile } from "@/elements-react/comparison-section/comparison-section-mobile";
import { FeatureGridMobile } from "@/elements-react/feature-grid/feature-grid-mobile";
import { BottomCtaMobile } from "@/elements-react/bottom-cta/bottom-cta-mobile";
import { B2bHeroMobile } from "@/elements-react/b2b-hero/b2b-hero-mobile";
import styles from "./b2b-page.module.scss";

export const B2bPageMobile: React.FC = withCatalogLayout(() => {

    return (
        <div className={styles.container}>
            <PageSectionLayout type={LayoutStyleTypes.TYPE_SM}>
                <TargetAudienceMobile />
                <WorkFasterMobile />
                <FeatureGridMobile />
                <ComparisonSectionMobile />
            </PageSectionLayout>
            <BottomCtaMobile />
        </div>
    );
});
